module.exports = __webpack_public_path__ + "img/marker_new.e8bc1c6a.svg";